import { library } from "@fortawesome/fontawesome-svg-core";
import { faEraser, faQrcode, faEllipsisV, faCamera, faCheck, faBoxOpen, faCaretRight, faCheckSquare, faWindowClose, faMapMarkerAlt, faCalendarAlt, faChevronUp, faChevronDown, faImages, faUserTie, faTruck } from "@fortawesome/free-solid-svg-icons";

function initFontAwesome() {
    library.add(faEraser, faQrcode, faEllipsisV, faCamera, faCheck, faBoxOpen, faCaretRight, faCheckSquare, faWindowClose, faMapMarkerAlt, faCalendarAlt, faChevronUp, faChevronDown, faImages, faUserTie, faTruck);
}
export default initFontAwesome;